export default __webpack_public_path__ + "static/media/complete.a3cfbd66.png";